<template>
  <div v-if="user">
    <h1>Profile</h1>
    <p>Email: <b>{{ user.email }}</b></p>
    <p>Username: <b>{{ user.name }}</b></p>
    <p v-if="user.firstName">First name: <b>{{ user.firstName }}</b></p>
    <p v-if="user.lastName">Last name: <b>{{ user.lastName }}</b></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Profile',
  computed: {
    ...mapState('auth', ['user']),
  },
};
</script>
